export const maintenanceScreen = 'core-maintenance-screen-registration-web'
export const subscriptionServicePreferredTier =
  'growth-utilize-preferred-tier-from-subscription-service-web'
export const dynamicRegistrationRemoveFundingSkip =
  'growth-dynamic-registration-remove-funding-skip-web'
export const dynamicRegistrationInvestSkip = 'growth-dynamic-registration-invest-skip-web'
export const plaidLayer = 'growth-plaid-layer-eligibility-web'
export const microsImplementation = 'growth-micros-implementation-web'
export const pricingToastCopyUpdate = 'growth-pricing-toast-copy-update-web'
export const suitabilityQuestionsInvestRevamp = 'growth-suitability-questions-invest-revamp-web'
export const suitabilityQuestionsLaterRevamp = 'growth-suitability-questions-later-revamp-web'
export const acornsEarlyGoldPrefill = 'growth-acorns-early-gold-prefill-web'
export const laterLanderRedesign = 'growth-later-lander-redesign-web'
export const removeEmailMfa = 'growth-remove-email-mfa-web'
export const laterOneTimeInvestmentRedesign = 'growth-later-one-time-investment-redesign-web'
